const Error = () => {
  return (
    <div className="flex items-center justify-center w-full h-80">
        <p className="text-red-300 text-center">مشکلی در برقراری ارتباط به وجود آمده.لطفا مجددا تلاش کنید </p>
    </div>
  )
}

export default Error